module.exports = __webpack_public_path__ + "media/images/riders/RACHEL_ATHERTON-59b455af0577a3eaeb613f9d939074cf.png";